import Link from "components/Link";
import LogoFinvueGlobal from "images/finvue_logo.svg";
import React from "react";
import LogoSvg from "./LogoSvg";

export interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "flex-shrink-0" }) => {
  return (
    <Link href="/" className={`finvue-logo inline-block text-white ${className}`}>
      <img src={LogoFinvueGlobal} alt="Finvue Logo" className="w-32 h-auto" />
    </Link>
  );
};

export default Logo;
